import * as React from 'react';
import './FileList.css';
import { CheckStatus } from '../services/CheckHashable';

type ReceiptFileStatus = 'pending'|CheckStatus;

interface ReceiptFile {
  status: ReceiptFileStatus;
  isHashed: boolean;
  name: string;
  errorReason?: string;
  insureName: string|null;
  prepareName: string|null;
};

interface FileListProps {
  files: ReceiptFile[];
  currentIndex: number;
  onClick: (index: number) => void;
};

export class FileList extends React.Component<FileListProps> {
  public render() {
    return (
      <div>
        <h2><span>ファイル一覧</span></h2>
        <div className='Counts'>
          <span>ファイル数: {this.fileCount}</span>
          <span>未匿名化ファイル数: {this.unhashedFileCount}</span>
          <span>エラー数: {this.errorFileCount}</span>
        </div>
        <div className={'Filename Header'}>
          <div>ファイル名</div>
          <div>状態</div>
          <div>匿名化</div>
          <div>社/国</div>
          <div>調剤月</div>
          <div></div>
        </div>
        {this.fileList}
      </div>
    );
  }

  private createClickHandler(i: number) {
    return () => this.props.onClick(i);
  }

  get fileCount() {
    return this.props.files.length;
  }

  get unhashedFileCount() {
    return this.props.files.filter(f => !f.isHashed ).length;
  }

  get errorFileCount() {
    return this.props.files.filter(f => f.errorReason).length;
  }

  get fileList() {
    return this.props.files.map((file, i) => {
      const className = [
        'Filename',
        file.isHashed ? 'Hashed' : '',
        file.errorReason ? "error": file.status
      ].join(' ');
      const reason = (file.errorReason ?
        <span className="reason">
          {file.errorReason}
        </span> :
        ''
      );

      return (
        // どうせ部分的に差し替わったりしないから `key={i}` でも良い
        <div key={i} className={className} onClick={this.createClickHandler(i)}>
          <div>{file.name}</div>
          <div className="status">{file.status}{reason}</div>
          <div>{file.isHashed ? '済' : '未'}</div>
          <div>{["", "社保", "国保"][Number(file.insureName)]}</div>
          <div>{file.prepareName}</div>
          <div className={this.props.currentIndex === i ? 'Current' : ''}>{''}</div>
        </div>
      );
    });
  }
}

